<div class="search-criteria">
  <div class="criteria-header"> {{criteriaTitle}} </div>
  <mat-select panelClass="criteria-dropdown-panel"
    (blur) = 'setErrorState()'
    (selectionChange) = 'setErrorState()'
    [ngClass]="errorState ? 'criteria-dropdown criteria-error':'criteria-dropdown'"
    [formControl]="form"
    [placeholder]="placeholderText">
    @for (option of searchOptions; track option) {
      <mat-option [value]="option">
        {{option.valueTitle}}
      </mat-option>
    }
  </mat-select>

  @if (errorState) {
    <div class="criteria-error-text mat-small">
      {{errorMessage}}
    </div>
  }
</div>
